export function getLevelBadgeColor(level: string | null | undefined): string {
  switch (level) {
    case 'tournament':
      return 'bg-orange-100 text-orange-700';
    case 'advanced':
      return 'bg-primary/10 text-primary';
    case 'intermediate':
      return 'bg-green-100 text-green-700';
    default:
      return 'bg-muted text-muted-foreground';
  }
}

export const SKILL_LEVELS = [
  { value: '', label: 'All Levels' },
  { value: 'beginner', label: 'Beginner' },
  { value: 'intermediate', label: 'Intermediate' },
  { value: 'advanced', label: 'Advanced' },
  { value: 'tournament', label: 'Tournament' },
] as const;

export const BALL_LEVELS = [
  { value: '', label: 'All Ball Levels' },
  { value: 'red', label: 'Red' },
  { value: 'orange', label: 'Orange' },
  { value: 'green', label: 'Green' },
  { value: 'yellow', label: 'Yellow' },
] as const;
